import Component from "flarum/common/Component";
export default class DiscussionThumbnail extends Component {
  view() {
    return m("img", {
      className: "Avatar DiscussionListItem-thumbnail",
      src: this.attrs.src
    });
  }
}
flarum.reg.add('fof-discussion-thumbnail', 'forum/components/DiscussionThumbnail', DiscussionThumbnail);